import { useSupabaseLoader } from "../../../server/supabase/hooks";

/** Surveys that haven't been archived (archiving sets `deleted_at`), open or closed. */
export function useSurveyCount(): ReturnType<typeof useSupabaseLoader<number>> {
  return useSupabaseLoader(async ({ supabase, account_id }) => {
    const { count, error } = await supabase
      .from("survey")
      .select("id", { count: "exact", head: true })
      .eq("account_id", account_id)
      .is("deleted_at", null);
    if (error) throw error;

    return count ?? 0;
  }, []);
}
